module.exports = __webpack_public_path__ + "static/media/sprite.23c6a17e.svg";